export const PortfolioImg7 = ({ pic, desc }) => {
  return (
    <div className="project-image-half-width">
      {/* <div className="image-filler"></div> */}
      <img src={pic} alt="image of project" />
    </div>
  );
};
